import React, { useCallback, useEffect, useRef, useState } from 'react';
import './AgGridActionsDropdown.scss';

export interface AgGridActionsDropdownItem {
  label: string;
  onClick: () => void;
}

interface AgGridActionsDropdownProps {
  items: AgGridActionsDropdownItem[];
}

const AgGridActionsDropdown: React.FC<AgGridActionsDropdownProps> = ({ items }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    const handleClickOutside = (e: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  const handleItemClick = useCallback((item: AgGridActionsDropdownItem) => {
    setIsOpen(false);
    item.onClick();
  }, []);

  return (
    <div className="ag-actions-dropdown" ref={containerRef}>
      <button
        type="button"
        className="ag-actions-dropdown__trigger"
        aria-haspopup="true"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((o) => !o)}
      >
        Actions ▾
      </button>
      {isOpen && (
        <div className="ag-actions-dropdown__menu" role="menu">
          {items.map((item, index) => (
            <div
              key={index}
              className="ag-actions-dropdown__item"
              role="menuitem"
              tabIndex={0}
              onClick={() => handleItemClick(item)}
              onKeyDown={(e) => e.key === 'Enter' && handleItemClick(item)}
            >
              {item.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AgGridActionsDropdown;
